import * as locales from 'date-fns/locale';
import type { Locale } from 'date-fns/locale/types';

/**
 * Reads the current browser language and attempts to returning a matching
 * locale object compatible with date-fns formatting.
 */
export const getLocale = () => {
  const allLocales: Record<string, Locale> = locales;
  const locale = navigator.language.replace('-', '');
  const rootLocale = locale.substring(0, 2);

  return allLocales[locale] || allLocales[rootLocale];
};
